import { TrendingUp, ArrowUpRight } from 'lucide-react';
import { useWallet } from '../../../../context/wallet/WalletContext';

const WalletStatsCard = () => {
  const { totalLifetimeEarnings, totalRedeemed } = useWallet();

  return (
    <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4">
      {/* Total Lifetime Commissions Card */}
      <div className="bg-white rounded-3xl p-4 sm:p-5 border border-slate-200/80 shadow-sm flex items-center justify-between gap-4">
        <div className="flex items-center gap-3.5 min-w-0">
          <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-2xl bg-emerald-50 border border-emerald-100 text-emerald-600 flex items-center justify-center shrink-0">
            <TrendingUp size={22} />
          </div>
          <div className="min-w-0">
            <span className="text-[11px] font-bold uppercase tracking-wider text-slate-400 block truncate">
              Lifetime Earned
            </span>
            <span className="text-xl sm:text-2xl font-bold text-slate-900 block truncate">
              ₹{totalLifetimeEarnings.toLocaleString('en-IN')}
            </span>
            <span className="text-[11px] text-slate-500 block mt-0.5 truncate">
              Total commissions generated
            </span>
          </div>
        </div>
      </div>

      {/* Total Redeemed Payouts Card */}
      <div className="bg-white rounded-3xl p-4 sm:p-5 border border-slate-200/80 shadow-sm flex items-center justify-between gap-4">
        <div className="flex items-center gap-3.5 min-w-0">
          <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-2xl bg-indigo-50 border border-indigo-100 text-indigo-600 flex items-center justify-center shrink-0">
            <ArrowUpRight size={22} />
          </div>
          <div className="min-w-0">
            <span className="text-[11px] font-bold uppercase tracking-wider text-slate-400 block truncate">
              Total Redeemed
            </span>
            <span className="text-xl sm:text-2xl font-bold text-slate-900 block truncate">
              ₹{totalRedeemed.toLocaleString('en-IN')}
            </span>
            <span className="text-[11px] text-slate-500 block mt-0.5 truncate">
              Withdrawn to account
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletStatsCard;
